module.exports = __webpack_public_path__ + "media/reskin-images/reports-42eee3a3.svg";